export class ProjectsRoutePaths {
  static home = '/home';

  static teamMain(teamId: string) {
    return `/${teamId}`;
  }

  static workspaceMain(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}`;
  }

  static workspaceReports(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/reports`;
  }

  static workspaceCompare(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/compare`;
  }

  static workspaceJourneyHeuristics(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/journey-heuristics`;
  }

  static workspaceWebsites(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/websites`;
  }

  static workspacePersonas(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/personas`;
  }

  static workspaceComparePrototypes(
    teamId: string,
    workspaceId: string,
    firstPrototypeId: string,
    secondPrototypeId: string
  ) {
    return `/${teamId}/${workspaceId}/compare/${firstPrototypeId}/${secondPrototypeId}`;
  }
}
